import React from 'react';
import { BellOutlined } from '@ant-design/icons';
import './index.less';

import type { NotificationType, NotifyConfig } from '../../controller';

function overWriteConfig(type: NotificationType, config: NotifyConfig) {
  const classMap = {
    open: 'noticeDefault',
    success: 'noticeSuccess',
    info: 'noticeInfo',
    warning: 'noticeWarning',
    error: 'noticeError',
  };
  const durationMap = {
    open: 4.5,
    success: 2,
    info: 2,
    warning: 4,
    error: 4,
  };

  let message = '';

  if (typeof config.message === 'string') {
    message = config.message.replace(
      config.message[0],
      config.message[0].toUpperCase(),
    );
  }

  if (message.length > 0 && config.description) {
    message += `: ${config.description}`;
  }

  if (message.length <= 0 && config.description) {
    message = config.description;
  }
  return {
    ...config,
    message,
    className: ['notice', classMap[type]].join(' '),
    icon: <BellOutlined />,
    duration: durationMap[type],
  };
}

export default overWriteConfig;
